const qs = require('qs');

module.exports = {
  parseSearch(search) {
    if (!search) {
      return {};
    }
    if (search.charAt(0) === '?') {
      search = search.slice(1);
    }
    return qs.parse(search);
  },
  parseQueryParam(url) {
    if (!url) {
      return {};
    }
    if (url.indexOf('?') > -1) {
      url = url.slice(url.indexOf('?') + 1);
    }
    return qs.parse(url);
  },
  addOrUpdateParameter(url = '', params = {}) {
    if (!url) {
      return '';
    }
    const indexOfQuery = url.indexOf('?');
    if (indexOfQuery > -1) {
      let currentParams = qs.parse(url.slice(indexOfQuery + 1));
      currentParams = {
        ...currentParams,
        ...params
      };
      url = `${url.slice(0, indexOfQuery)}?${qs.stringify(currentParams)}`;
    } else {
      url = `${url}?${qs.stringify(params)}`;
    }
    return url;
  },
  removeParameters(url, ...parameters) {
    const parsed = new URL(url);
    parameters.forEach(e => parsed.searchParams.delete(e));
    return parsed.toString();
  }
};
